<template>
  <div class="card-body">
    <fieldset v-if="diaries.length">
      <legend>Todo</legend>

      <diary-entry
        :diary="diary"
        :readonly="readonly"
        :key="`diaries-${index}`"
        v-for="(diary, index) in diaries"
        @complete="complete(diary, index)"
      ></diary-entry>
    </fieldset>

    <fieldset v-if="!readonly">
      <legend>
        Next Step
        <small>- Set the next step to be completed for this claim</small>
      </legend>

      <inputbox
        name="title"
        label="Next Step"
        v-model="form.title"
        helper="Please enter the next step to diary for this claim"
        :show-error="form.errors.has('title')"
        :error-message="form.errors.get('title')"
        :required="true"
      ></inputbox>

      <input-block
        name="description"
        label="Additional Information"
        v-model="form.description"
        helper="Please enter any additional information for the next step of this claim"
        :show-error="form.errors.has('description')"
        :error-message="form.errors.get('description')"
        :required="true"
      ></input-block>

      <selectlist
        name="type"
        placeholder="Please Select"
        v-model="form.user_id"
        label="Handler"
        :options="handlers"
        :show-error="form.errors.has('user_id')"
        label-name="full_name"
        :error-message="form.errors.get('user_id')"
        key-name="id"
      ></selectlist>

      <div
        class="form-group"
        :class="{ 'has-error': form.errors.has('date_time') }"
      >
        <div class="col-lg-4">
          <label class="control-label">Due Date:</label>
          <p class="help-block">Please enter the date that this is for</p>
        </div>
        <div class="col-md-8">
          <datepicker
            name="date_time"
            format="dd/MM/yyyy"
            input-class="form-control"
            v-model="form.date_time"
          >
          </datepicker>
          <p
            class="text-danger"
            v-if="form.errors.has('date_time')"
            v-text="form.errors.get('date_time')"
          ></p>
        </div>
      </div>

      <div class="text-right half-gutter-right half-gutter-bottom">
        <form-button :indicator="form.processing()" v-on:clicked="saveDiary">
          Save Diary Entry
        </form-button>
      </div>
    </fieldset>

    <fieldset>
      <legend>Diary</legend>

      <diary-entry
        :diary="diary"
        :readonly="true"
        :key="`completed-diaries-${index}`"
        v-for="(diary, index) in completedDiaries"
      ></diary-entry>
    </fieldset>
  </div>
</template>

<script>
import DiaryEntry from '@/components/Modules/Shared/Children/DiaryEntry';

export default {
  props: {
    slim: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    },
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    DiaryEntry
  },

  data() {
    return {
      form: new window.Form(
        {
          title: null,
          description: null,
          date_time: null,
          user_id: null
        },
        true
      ),
      diaries: [],
      completedDiaries: []
    };
  },

  computed: {
    handlers() {
      return this.$store.getters['ClaimHandlers/all'];
    },

    user() {
      return this.$store.getters.user;
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');

    this.getDiary();
  },

  methods: {
    getDiary() {
      window.Ajax.get(`/diary?filter[incident_id]=${this.incident}`)
        .then(response => {
          const diaries = response.data || [];

          this.diaries = diaries.filter(diary => !diary.completed_at);
          this.completedDiaries = diaries.filter(diary => !!diary.completed_at);
        })
        .catch(response => {});
    },

    saveDiary() {
      if (this.readonly) {
        return;
      }

      this.form.addData('url', this.url);
      this.form.addData('incident', this.incident);

      this.form
        .post('/diary')
        .then(response => {
          this.form.title = null;
          this.form.description = null;
          this.form.date_time = null;

          this.diaries.push(response);

          window.toastify.success(
            'Saved!',
            'The diary entry was saved successfully!'
          );
        })
        .catch(error => {});
    },

    complete(diary, index) {
      if (this.readonly) {
        return;
      }

      window
        .swal({
          title: 'Are you sure you want to complete the diary?',
          type: 'warning',
          showCancelButton: true
        })
        .then(
          () => {
            window.Ajax.post(
              `/diary/${this.incident}/${diary.identifier}/complete`
            )
              .then(response => {
                this.diaries.splice(index, 1);
                this.completedDiaries.unshift(response.data);
              })
              .catch(response => {});
          },
          dismiss => {}
        );
    }
  },

  watch: {
    handlers: {
      handler(users) {
        if (
          !this.form.user_id &&
          users.map(user => user.id).includes(this.user.id)
        ) {
          this.form.user_id = this.user.id;
        }
      },
      immediate: true
    }
  }
};
</script>
